import { get } from '../../../utils/api';

export default {
  getGifts: () => get({ url: 'sailplay/gifts' }),
};
